<template>
    <div>
        <p class="pb-3">
            {{label}}
        </p>
        <star-rating 
            v-model="answerSend" 
            :rtl="$vs.rtl" 
            :increment="1"  
            :max-rating="maxRanking"          
            :read-only="disabled"
           ></star-rating>      
    </div>
</template>

<script type="text/javascript">
    import { mapState, mapMutations } from 'vuex';
    import StarRating from 'vue-star-rating';
    export default {
        components: { StarRating },
        props: {
            label: {
                type: String,
                required: false,
                default: 'Descripción'
            },
            answer: {
                type:  [String, Number],
                required: false,
                default: 0
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },             
        computed: {
            ...mapState('resource', ['indexQuestion', 'questionsByPage']), 
            maxRanking() {
                return this.questionsByPage[this.indexQuestion].properties.size;
            },        
           
            answerSend: {
                get() {                    
                    if(this.answer === '') return 0;
                    const convertToSgtring = parseInt(this.answer)
                    return convertToSgtring;
                },
                set(value) {                    
                    this.$emit('input', String(value))
                }
            }
        }
        
    }    
</script>